<script>
	import Navbar from "../Navbar.svelte";
	import Footer from "../components/Footer.svelte";
	import { handleSubmit, parseFormdata, updateNextRoute } from "../utils.js";
	import { api_writeForm, disableNextButton } from "../stores.js";
	import { useForm, validators, required, Hint } from "svelte-use-form";
	// https://svelte.dev/repl/d4fc02f688d4ad0b3ceb9ac44c9be9?version=3.34.0

	export let redirectRoute;
	updateNextRoute();
	redirectRoute = localStorage.getItem("nextRoute");
	const form = useForm();

	const handleClick = () => {
		handleSubmit($api_writeForm, parseFormdata($form), redirectRoute);
	};

	const mustBeInteger = (x) => {
		if (isNaN(Number(x)) || Number(x) < 0 || Number(x) > 99) {
			console.log("not a valid number");
			return { mustBeInteger: true };
		}
	};

	let fields = [
		{
			labelName: "ses_ladder",
			label: "Where would you place yourself on this ladder?",
			options: [
				{
					type: "radio",
					value: "9", // value/response to send to server
					option: "9 (top of ladder)", // what to display
					validate: [required],
				},
				{
					type: "radio",
					value: "8", // value/response to send to server
					option: "8", // what to display
					validate: [required],
				},
				{
					type: "radio",
					value: "7", // value/response to send to server
					option: "7", // what to display
					validate: [required],
				},
				{
					type: "radio",
					value: "6", // value/response to send to server
					option: "6", // what to display
					validate: [required],
				},
				{
					type: "radio",
					value: "5", // value/response to send to server
					option: "5 (middle of ladder)", // what to display
					validate: [required],
				},
				{
					type: "radio",
					value: "4", // value/response to send to server
					option: "4", // what to display
					validate: [required],
				},
				{
					type: "radio",
					value: "3", // value/response to send to server
					option: "3", // what to display
					validate: [required],
				},
				{
					type: "radio",
					value: "2", // value/response to send to server
					option: "2", // what to display
					validate: [required],
				},
				{
					type: "radio",
					value: "1", // value/response to send to server
					option: "1 (bottom of ladder)", // what to display
					validate: [required],
				},
			],
		},
		{
			labelName: "ses_income",
			label: "Information about income is very important to understand. In the previous year, what was your entire household's income, before taxes?",
			options: [
				{
					type: "radio",
					value: "0_less-than-10k",
					option: "Less than $10,000",
					validate: [],
				},
				{
					type: "radio",
					value: "1_0k-9k",
					option: "$10,000 to $19,999",
					validate: [],
				},
				{
					type: "radio",
					value: "2_20k-29k",
					option: "$20,000 to $29,999",
					validate: [],
				},
				{
					type: "radio",
					value: "3_0k-39k",
					option: "$30,000 to $39,999",
					validate: [],
				},
				{
					type: "radio",
					value: "4_40k-49k",
					option: "$40,000 to $49,999",
					validate: [],
				},
				{
					type: "radio",
					value: "5_50k-59k",
					option: "$50,000 to $59,999",
					validate: [],
				},
				{
					type: "radio",
					value: "6_60k-69k",
					option: "$60,000 to $69,999",
					validate: [],
				},
				{
					type: "radio",
					value: "7_70k-79k",
					option: "$70,000 to $79,999",
					validate: [],
				},
				{
					type: "radio",
					value: "8_80k-89k",
					option: "$80,000 to $89,999",
					validate: [],
				},
				{
					type: "radio",
					value: "9_90k-99k",
					option: "$90,000 to $99,999",
					validate: [],
				},
				{
					type: "radio",
					value: "10_100k-149k",
					option: "$100,000 to $149,999",
					validate: [],
				},
				{
					type: "radio",
					value: "11_150k-or-more",
					option: "$150,000 or more",
					validate: [],
				},
			],
		},
		{
			labelName: "ses_education-level",
			label: "What is the highest level of education you have completed?",
			options: [
				{
					type: "radio",
					value: "1_less-than-high-school",
					option: "Less than high school",
					validate: [required],
				},
				{
					type: "radio",
					value: "2_high-school-diploma",
					option: "High school diploma",
					validate: [required],
				},
				{
					type: "radio",
					value: "3_vocational-training",
					option: "Vocational training",
					validate: [required],
				},
				{
					type: "radio",
					value: "4_attended-college",
					option: "Attended college",
					validate: [required],
				},
				{
					type: "radio",
					value: "5_bachelors",
					option: "Bachelor's Degree",
					validate: [required],
				},
				{
					type: "radio",
					value: "6_graduate-degree",
					option: "Graduate Degree",
					validate: [],
				},
				{
					type: "radio",
					value: "0_unsure-unknown-other",
					option: "Unsure/unknown/other",
					validate: [],
				},
			],
		},
		{
			labelName: "ses_education-years",
			label: "How many years of formal education have you completed?",
			options: [
				{
					// type: "Number",
					value: "", // value/response to send to server
					option: "", // what to display
					validate: [required, mustBeInteger],
				},
			],
			hintText:
				"Enter only a valid number. If it's twelve years, enter just 12.",
		},
	];

	// fields = fields.slice(fields.length - 2, fields.length);
</script>

<Navbar />

<section>
	<h1>Questionnaire</h1>
	<p>
		Think of the ladder below as representing where people stand in your
		country.
	</p>
	<p>
		At the <strong>top</strong> of the ladder are the people who are the
		best off—those who have the most money, the most education and the most
		respected jobs. At the <strong>bottom</strong> are the people who are the
		worst off—those who have the least money, least education, and the least
		respected jobs or no job.
	</p>
	<p>
		The higher up you are in this ladder, the closer you are to the people
		at the very top; the lower you are, the closer you are to the people at
		the very bottom.
	</p>
	<img src="../img/ladder.png" alt="ladder" />

	<form use:form>
		{#each fields as field, fi}
			<div class="field-container">
				<label for={field.labelName}>{field.label} </label>
				{#each field.options as option, oi}
					<div class="option-group">
						<input
							name={field.labelName}
							type={option.type}
							value={option.value}
							use:validators={option.validate}
						/>
						<span class="option"> {option.option} </span>
					</div>
				{/each}
				{#if field.labelName === "ses_education-years"}
					<Hint for={field.labelName} on="mustBeInteger">
						<span style="color:red">{field.hintText}</span>
					</Hint>
				{/if}
			</div>
		{/each}

		<button
			disabled={!$form.valid && $disableNextButton}
			on:click|preventDefault={handleClick}>Next</button
		>
	</form>
</section>

<Footer />

<style>
	@media (max-width: 700px) {
		section {
			padding-left: 8%;
			padding-right: 8%;
		}
	}

	button {
		margin-bottom: 144px;
	}

	label {
		margin-bottom: 13px;
		font-size: 1.1em;
	}

	input {
		margin-right: 1px;
	}

	.field-container {
		margin-bottom: 34px;
	}

	.option {
		margin-right: 13px;
	}

	.option-group {
		display: block;
	}

	@media (max-width: 1150px) {
		.option-group {
			display: block;
		}
	}

	img {
		display: block;
		max-width: 144px;
	}
</style>
